(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["relais-footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{if(location.hash==='#contact_form'){const f=document.querySelector('#contact details');if(f)f.open=true;}});

  } catch(e) { console.error(e); }
})();
})();
